import Lottie from "lottie-react";
import { yetiStudentLogin } from "../../../../appAssets";
import saveJournalJson from "../../../../appAssets/jsons/save_journal.json";
import { JOURNAL_STRINGS } from "../../types";
import "./ConfirmationPopup.scss";
import crossIcon from "../../../../../assets/Icons/cross.png";

interface ConfirmationPopupProps {
  /** Save & continue */
  onYes: () => void;
  /** Discard & navigate away */
  onNo: () => void;
  /** Close button (top-right) */
  onClose: () => void;
}

/**
 * Mirrors srcMobile DisplayConfirmationPopUp invoked from KidsJournal.
 * Shown when leaving the screen with unsaved work.
 */
function ConfirmationPopup({ onYes, onNo, onClose }: ConfirmationPopupProps) {
  return (
    <div className="journal-confirm">
      <div className="journal-confirm__card">
        <div className="journal-confirm__inner">
          <div className="journal-confirm__header">
            <p className="journal-confirm__title">
              {JOURNAL_STRINGS.saveYourWork}
            </p>
            <button
              type="button"
              className="journal-confirm__close"
              onClick={onClose}
              aria-label="Close"
            >
              <img src={crossIcon} alt="cancel" className="close_icon" />
              {/* <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg> */}
            </button>
          </div>

          <Lottie
            animationData={saveJournalJson}
            loop={false}
            autoplay={false}
            className="journal-confirm__icon"
          />

          <div className="journal-confirm__buttons">
            <button
              type="button"
              className="journal-confirm__btn journal-confirm__btn--secondary"
              onClick={onNo}
            >
              No
            </button>
            <button
              type="button"
              className="journal-confirm__btn"
              onClick={onYes}
            >
              Yes
            </button>
          </div>
        </div>
        {/* <img src={yetiStudentLogin} alt="" className="journal-confirm__yeti" /> */}
      </div>
    </div>
  );
}

export default ConfirmationPopup;
